<template>
  <div class="app-container">
    <!-- 使用 v-if 避免无效 URL -->
    <iframe
      v-if="iframeUrl"
      :src="iframeUrl"
      id="mapIframe"
      frameborder="0"
      @load="onIframeLoaded"
      @error="onIframeError"
    ></iframe>
    <div v-else class="error-message">缺少运单号，无法加载地图</div>
  </div>
</template>

<script>
const baseInvoice = process.env.VUE_APP_TRAJECTORY;
export default {
  name: 'MapsTrajectory',
  props: {
    queryTrackParam: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      // 是否格式化成巴西时间
      isTormat: false,
      tableData: []
    }
  },
  computed: {
    // 动态计算 iframe URL
    iframeUrl() {
      const navigatorLanguage = navigator.language.toLowerCase().indexOf('zh') > -1 ? 'zh' : 'pu';
      const language = sessionStorage.getItem('language') || navigatorLanguage;
      if (!this.queryTrackParam?.waybillNumber) return null;
      return `${baseInvoice}/route-map?source=internal&language=${language}&waybillNumber=${this.queryTrackParam.waybillNumber}`
    }
  },
  methods: {
    onIframeLoaded() {
      console.log('iframe 加载成功');
    },
    onIframeError() {
      console.error('iframe 加载失败，请检查网络或 URL')
    }
  }
}
</script>

<style scoped>
.app-container >>> .el-table__row {
  font-weight: bold;
}
#mapIframe {
  width: 100%;
  height: 70vh;
}
.error-message {
  color: red;
  padding: 20px;
  text-align: center;
}
</style>
